import Vue from 'vue'
import Router from 'vue-router'
import AdminDashboard from '@/pages/AdminDashboard/AdminDashboard'
import login from '@/pages/login/login'

import ResetPassword from '@/pages/ResetPassword/ResetPassword'
import signup from '@/pages/signup/signup'
import signupconfirm from '@/pages/signupconfirm/signupconfirm'
import OrganizationDetails from '@/pages/OrganizationDetails/OrganizationDetails'
import addpersonnel from '@/pages/addpersonnel/addpersonnel'

import LocationPools from '@/pages/Administration/location_pools'
import Positions from '@/pages/Administration/Positions'
import Certificates from '@/pages/Administration/Certificates'
import ChemicalSettings from '@/pages/Administration/Chemical_Settings'
//

import PersonalPostSignup from '@/pages/UpdatePersonnel/UpdatePersonnel'


import checklistlanding from '@/pages/checklistLanding/checklistlanding'
import activitylist from '@/pages/activitylist/activitylist'

//FG - FOOF - Change for certification - FOR SAFETY PLAN - added safety plan choice to nav
import safetyplanmanagement from '@/pages/Compliance/safetyplan_management'

import compliancemanagement from '@/pages/Compliance/compliance_management'
import compliancemahc from '@/pages/Compliance/mahc'
import controlplan from '@/pages/RiskManagement/control_plan'
import memberships from '@/pages/Patrons/memberships'
import suppliers from '@/pages/Administration/suppliers'
import inventory from '@/pages/HealthSafety/inventory'
import riskmanagement from '@/pages/RiskManagement/risk_management'
import maintenance from '@/pages/HealthSafety/maintenance'

import administrator from '@/pages/Administrator/administrator'

import compliancedoc from '@/pages/Compliance/compliance_doc'

import training from '@/pages/HealthSafety/training'
import incidents from '@/pages/HealthSafety/IncidentAccident/incidents'

import evals from '@/pages/Administration/EvalManage'

//ImportModules don't delete this line
// import checklist  from '@/pages/checklist/checklist'

import ChecklistManager from '@/pages/ChemicalChecklist/ChecklistManager.vue'
import ChemicalRecord from '@/pages/ChemicalRecord/ChemicalRecord.vue'
import Dashboard from '@/pages/Dashboard/Dashboard.vue'
import ProfileDashboard from '@/pages/ProfileDashboard/profiledashboard.vue'

import CustomReadings from '@/pages/Administration/custom_readings.vue'
import CustomMaintenance from '@/pages/Administration/custom_maintenance.vue'
import CustomTasks from '@/pages/Administration/custom_tasks.vue'

import ComingSoon from '@/pages/under_construction/under_construction.vue'
import AddCertificates from '@/pages/Certificates/certificates.vue'
import ManagePools from '@/pages/Administration/ManagePools/ManagePools.vue'
import ManageLocations from '@/pages/Administration/ManageLocation/managelocation.vue'

//ImportModules don't delete this line
Vue.use(Router)

export default new Router({
  routes: [{
      path: '*',
      redirect: '/login'
    }, {
      path: '/AdminDashboard',
      name: 'AdminDashboard',
      component: AdminDashboard,
      props: {
        default: {
          name: 'Admin Dashboard'
        }
      },
    }, {
      path: '/login',
      name: 'login',
      component: login,
      props: {
        default: {
          name: 'Login'
        }
      },
    }, {

      path: '/resetpassword/',
      name: 'resetpassword',
      component: ResetPassword,
      props: {
        default: {
          name: 'Reset Password'
        }
      },

    }, {
      path: '/signup',
      name: 'signup',
      component: signup,
      props: {
        default: {
          name: 'SignUp'
        }
      },
    }, {
      path: '/signupconfirm',
      name: 'signupconfirm',
      component: signupconfirm,
      props: {
        default: {
          name: 'Signup Confirm'
        }
      },
    }, {
      path: '/OrganizationDetails',
      name: 'OrganizationDetails',
      component: OrganizationDetails,
      props: {
        default: {
          name: 'Organizational Details'
        }
      },
    }, {
      path: '/addpersonnel',
      name: 'addpersonnel',
      component: addpersonnel,
      props: {
        default: {
          name: 'Personnel Profile'
        }
      },
    }, {
      path: '/UpdatePersonnel/:id',
      name: 'UpdatePersonnel',
      component: PersonalPostSignup,
      props: {
        default: {
          name: 'Personnel Profile'
        }
      },
    }, {
      path: '/startchecklist',
      name: 'checklistlanding',
      component: checklistlanding,
      props: {
        default: {
          name: 'Checklists'
        }
      },
    }, {
      path: '/checklistmanager',
      name: 'checklistmanager',
      component: ChecklistManager,
      props: {
        default: {
          name: 'Checklist Management'
        }
      },
    },

    {
      path: '/chemicalrecord',
      name: 'chemicalrecord',
      component: ChemicalRecord,
      props: {
        default: {
          name: 'Readings and Tasks '
        }
      },
    },

    {
      path: '/aquaticpoolsvenues',
      name: 'locationpools',
      component: LocationPools,
      props: {
        default: {
          name: 'Manage Aquatic Facilities And Venues'
        }
      },
    },

    {
      path: '/positions',
      name: 'positions',
      component: Positions,
      props: {
        default: {
          name: 'Manage Positions'
        }
      },
    }, {
      path: '/certificates',
      name: 'certificates',
      component: Certificates,
      props: {
        default: {
          name: 'Manage Certificates'
        }
      },
    },


    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      props: {
        default: {
          name: ''
        }
      },
    },


    {
      path: '/chemicalsettings',
      name: 'chemicalsettings',
      component: ChemicalSettings,
      props: {
        default: {
          name: 'Templates'
        }
      },
    },


    {
      path: '/activitylist',
      name: 'activitylist',
      component: activitylist,
      props: {
        default: {
          name: 'Activities'
        }
      },
    }, {
      path: '/comingsoon',
      name: 'comingsoon',
      component: ComingSoon,
      props: {
        default: {
          name: 'Under Construction'
        }
      },
    },

    //FG - FOOF - Change for certification - FOR SAFETY PLAN - added safety plan choice to nav
    
    {
      path: '/Safetyplan-management',
      //name: 'Safetyplan Management',
      name: 'safetyplanmanagement', //FG - FOOF - After Cert - First Release (7) - changed from Safetyplan Management
      component: safetyplanmanagement,
      props: {
        default: {
          name: 'Safetyplan Management'
          //name: 'safetyplanmanagement' //FG - FOOF - After Cert - First Release (7) - changed from Safetyplan Management
        }
      },
    },
    

    {
      path: '/Compliance-management',
      name: 'Compliance Management',
      component: compliancemanagement,
      props: {
        default: {
          name: 'Compliance Management'
        }
      },
    }, {
      path: '/mahc-wiki',
      name: 'MAHC Details',
      component: compliancemahc,
      props: {
        default: {
          name: 'MAHC Details'
        }
      },
    },

    {
      path: '/control-plan',
      name: 'control plan',
      component: controlplan,
      props: {
        default: {
          name: 'Control Plan Management'
        }
      },
    },

    {
      path: '/account-management',
      name: 'memberships',
      component: memberships,
      props: {
        default: {
          name: 'Account Management'
        }
      },
    }, {
      path: '/suppliers',
      name: 'suppliers',
      component: suppliers,
      props: {
        default: {
          name: 'Supplier Management'
        }
      },
    }, {
      path: '/new-inventory',
      name: 'inventory',
      component: inventory,
      props: {
        default: {
          name: 'Inventory Management'
        }
      },
    }, {
      path: '/risk-management',
      name: 'riskmanagement',
      component: riskmanagement,
      props: {
        default: {
          name: 'Potential Hazard'
        }
      },
    }, {
      path: '/compliancedoc-mangement',
      name: 'compliancedoc',
      component: compliancedoc,
      props: {
        default: {
          name: 'Compliance Document'
        }
      },
    }, {
      path: '/usermanagement',
      name: 'administrator',
      component: administrator,
      props: {
        default: {
          name: ''
        }
      },
    }, {
      path: '/maintenance-items',
      name: 'maintenance',
      component: maintenance,
      props: {
        default: {
          name: 'Maintenance'
        }
      },
    }, {
      path: '/training',
      name: 'training',
      component: training,
      props: {
        default: {
          name: 'Training'
        }
      },
    }, {
      path: '/incidents',
      name: 'incidents',
      component: incidents,
      props: {
        default: {
          name: 'Manage Incidents'
        }
      },
    }, {
      path: '/personneldashboard',
      name: 'PersonnelDashboard',
      component: ProfileDashboard,
      props: {
        default: {
          name: 'Personnel Dashboard'
        }
      },
    }, , {
      path: '/evaluationmanagement',
      name: 'EvalManage',
      component: evals,
      props: {
        default: {
          name: 'Evaluation Management'
        }
      },
    }, {
      path: '/customreadings',
      name: 'customreadings',
      component: CustomReadings,
      props: {
        default: {
          name: 'Manage Custom Readings'
        }
      },
    }, {
      path: '/custommaintenance',
      name: 'custommaintenance',
      component: CustomMaintenance,
      props: {
        default: {
          name: 'Manage Custom Maintenance'
        }
      }, 
    }, {
      path: '/customtasks',
      name: 'customtasks',
      component: CustomTasks,
      props: {
        default: {
          name: 'Manage Custom Task'
        }
      },
    },
    {
      path: '/addcertificates',
      name: 'certificates',
      component: AddCertificates,
      props: {
        default: {
          name: 'AddCertificates'
        }
      }
    },
    {
      path: '/managepools',
      name: 'managepools',
      component: ManagePools,
      props: {
        default: {
          name: 'Manage Venue'
        }
      }
    },
    {
      path: '/managelocation',
      name: 'managelocation',
      component: ManageLocations,
      props: {
        default: {
          name: 'Manage Facility'
        }
      }
    },
    //routes don't delete this line
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js